import { render, staticRenderFns } from "./FormFAQEditor.vue?vue&type=template&id=5685b84c"
import script from "./FormFAQEditor.vue?vue&type=script&lang=js"
export * from "./FormFAQEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports